import BaseUserService from './BaseUserService';
import Constants from '../utils/constants';
import moment from 'moment';

const path = 'leave-request';

export default class LeaveRequestService extends BaseUserService {
    // Initializing important variables
    constructor() {
        super(path);
        this.path = path;
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            firstname: criteria.firstName,
            lastname: criteria.lastName,
            type: criteria.type?.enumValue,
            status: criteria.status?.enumValue,
            date_from: criteria.dateFrom ? moment(criteria.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            date_to: criteria.dateTo ? moment(criteria.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT) : undefined,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            absenceReason: criteria?.absenceReason ? criteria.absenceReason.id : null
        });
    }

    add(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    addOwn(element) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/own/`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element) {
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    updateOwn(element) {
        return this.fetch(`${this.domain}/${this.path}/own/`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    accept(id, leftDaysNumber) {
        return this.fetch(`${this.domain}/${this.path}/accept/${id}`, {
            method: 'PUT',
        
                body : parseInt(leftDaysNumber),
        
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    reject(element) {
        return this.fetch(`${this.domain}/${this.path}/reject`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    leaveRequestEvents(date, employeeId){
   // Get current employee leave requests for full calendar
   let currentDate = moment(date).format(Constants.DATE_JSON_FORMAT);
   let url = employeeId !== undefined ? `${this.domain}/${this.path}/events/${currentDate}?employeeId=${employeeId}` :
   `${this.domain}/${this.path}/events/${currentDate}`;
        return this.fetch(url, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    getAvailableDays(employeeId){
        let url = '';
        if(employeeId !== null){
            url = `${this.domain}/${this.path}/available-days/?employeeId=${employeeId}`;
        } else {
            url = `${this.domain}/${this.path}/available-days/?`;
        }
        return this.fetch(url, {
            method: 'GET'
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    countDaysLeaveToUse(leaveRequestId){
        let url = '';
        url = `${this.domain}/${this.path}/count-left-days/${leaveRequestId}`;
        return this.fetch(url, {
            method: 'GET'
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }


}
